export default {
  authenticated: ({ user }) => (user === null ? false : !user.expired),

  accessToken: ({ user }) => (user === null ? null : user.access_token),

  tokenType: ({ user }) => (user === null ? null : user.token_type),

  pilotPlan: ({ profile }) => (profile === null ? null : profile.pilotPlan),

  goalsAndObjectivesFlag: ({ profile }) => (profile === null ? null : profile.goalsAndObjectivesFlag),  

  expiresAt: ({ user }) => (user === null ? null : user.expires_at),

  role: ({ user }) => (user === null ? null : user.profile.role),

  fullProfile({ user }) {    
    if (user != undefined && user.profile != undefined) {
      let userProfile = {
        ...user.profile,
        municipalityId: user.profile.municipalityid,
        districtId: user.profile.districtid,
        centerId: user.profile.centerid,
        roleId: user.profile.roleid,
      };
      Object.keys(userProfile).forEach(
        (key) => userProfile[key] === undefined && delete userProfile[key]
      );
      return userProfile;
    }
    return undefined;
  },

  profile({ user }) {
    if (user === null) {
      return null;
    }
    const { name, sub } = user.profile;
    return {
      id: sub,
      name,
    };
  },

  companies({ companies }) {
    return companies || [];
  },

  healthRegions({ healthRegions }) {
    return healthRegions || [];
  },

  serviceCenters({ serviceCenters }) {
    return serviceCenters || [];
  },

  mainCompany: ({ companies }) =>
    companies && companies.length ? companies.find((x) => x.main) : false,

  hasPermissions: ({ permissions }) => (_permissions) =>
    permissions && permissions.length
      ? permissions.some((permission) => _permissions.includes(permission))
      : false,

  selectedMenuItem({ userMenu, menuItemId }) {
    const menuItem = userMenu.find((x) => x.id == menuItemId);

    if (!menuItem) return [];

    return menuItem.children.map((item) => ({
      description: item.description,
      detail: item.detail,
      hoverImage: item.mainImageHoverPath,
      icon: item.iconClasses,
      mainImage: item.mainImagePath,
      needSelectedStudent: item.needSelectedStudent,
      route: item.navigationPath,
      title: item.title,
    }));
  },

  getSiteMap: function(state) {
    return state.userMenu;
  },
};
